import React, { Fragment, useCallback, useEffect, useState } from 'react'
import UserLayout from '../../layouts/UserLayout'
import {
	Backdrop,
	Box,
	Button,
	Card,
	Checkbox,
	Chip,
	CircularProgress,
	FormControlLabel,
	Radio,
	TextField,
	Typography,
	useMediaQuery,
} from '@mui/material'
import { DOMAIN, api } from '../../utils/api'
import axios from 'axios'
import { handleError } from '../../utils/error'
import { currentUserActions } from '../../redux/store'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getFromStorage } from '../../utils/storage'
import { transformDetailWithPhone } from '../../utils/transformDetail'
import { mainBlue, mainGreen, mainRed } from '../../utils/color'

const styleOrder = {
	position: 'relative',
	background: '#fff',
	padding: '5px 10px 12px 10px',
	borderRadius: '15px',
	boxShadow: 'rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px',
}

export default function ShippingServiceOrder() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const mediaMd = useMediaQuery('(min-width:768px)')
	const token = getFromStorage('current-user')?.accessToken
	const [loading, setLoading] = useState(false)
	const { currentUser } = useSelector((state) => state.currentUser)
	const [allProducingOrders, setAllProducingOrders] = useState([])
	const [currentImage, setCurrentImage] = useState(null)
	const [isViewerOpen, setIsViewerOpen] = useState(false)
	const [shippingServices, setShippingServices] = useState([])
	const [shippingFee, setShippingFee] = useState('')
	const [showShippingServicesBackdrop, setShowShippingServicesBackdrop] = useState(false)
	const [shippingService, setShippingService] = useState('')
	const [currentOrder, setCurrentOrder] = useState('')
	const [currentOrderCode, setCurrentOrderCode] = useState('')

	const openImageViewer = (photo) => {
		setCurrentImage(photo)
		setIsViewerOpen(true)
	}

	const closeImageViewer = () => {
		setCurrentImage(null)
		setIsViewerOpen(false)
	}

	const getAllProducingOrders = useCallback(
		async function () {
			try {
				setLoading(true)
				const response = await axios({
					url: `${DOMAIN}/producing-orders/${currentUser.store}`,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})

				setAllProducingOrders(
					response.data.map((item) => ({
						...item,
						checked: item.shippingFee || item.shippingFee === 0 ? true : false,
					})),
				)
				setLoading(false)
			} catch (error) {
				handleError(error)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[token, dispatch, navigate, currentUser.store],
	)

	useEffect(() => {
		getAllProducingOrders()
	}, [getAllProducingOrders])

	const getShippingServices = useCallback(
		async function () {
			try {
				const response = await axios({
					url: api.GET_ALL_SHIPPING_SERVICES,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					method: 'GET',
					withCredentials: true,
				})
				setShippingServices(response.data)
				setShippingService(response.data[0]?._id)
			} catch (error) {
				handleError(error)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[token, dispatch, navigate],
	)

	useEffect(() => {
		getShippingServices()
	}, [getShippingServices])

	const handleChangeCheck = async (e, item) => {
		let { checked } = e.target
		if (checked === true) {
			setCurrentOrder(item._id)
			setCurrentOrderCode(item.shiftCode + item.shiftIndex)
			setShowShippingServicesBackdrop(true)
		} else if (checked === false) {
			try {
				const response = await axios({
					url: api.HANDLE_SHIPPING_FEE,
					headers: {
						Authorization: `Bearer ${token}`,
					},
					data: { shippingFee: undefined, orderId: item._id },
					method: 'PUT',
					withCredentials: true,
				})
				if (response.data.message) {
					alert(response.data.message)
				}
				await getAllProducingOrders()
				setCurrentOrder('')
				setCurrentOrderCode('')
			} catch (error) {
				handleError(error)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		}
	}

	const handleChangeShippingService = (e) => {
		setShippingService(e.target.value)
	}

	const handleChangeShippingFee = (e) => {
		let { value } = e.target
		const removeChar = value.replace(/[^0-9.]/g, '')
		const removeDot = removeChar.replace(/\./g, '')
		const formatedNumber = removeDot.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
		setShippingFee(formatedNumber)
	}

	const handleShippingFee = async function (orderId) {
		if (shippingFee.trim() === '') {
			return
		} else if (Number(shippingFee) < 0) {
			alert('Tiền ship không hợp lệ!')
			return
		}
		const parseShippingFee = Number(shippingFee.replace(/\D/g, ''))

		try {
			setShippingFee('')
			const response = await axios({
				url: api.HANDLE_SHIPPING_FEE,
				headers: {
					Authorization: `Bearer ${token}`,
				},
				data: { shippingFee: parseShippingFee, orderId },
				method: 'PUT',
				withCredentials: true,
			})
			if (response.data.message) {
				alert(response.data.message)
			}
			await getAllProducingOrders()
			setCurrentOrder('')
			setCurrentOrderCode('')
			setShowShippingServicesBackdrop(false)
		} catch (error) {
			handleError(error)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	const handleShippingService = async function (orderId) {
		const orders = allProducingOrders?.filter((item) => item.checked).map((item) => item._id)
		if (orders.length === 0 || !shippingService) return
		try {
			setShippingFee('')
			const response = await axios({
				url: api.HANDLE_SHIPPING_SERVICE,
				headers: {
					Authorization: `Bearer ${token}`,
				},
				data: { orders, shippingService },
				method: 'PUT',
				withCredentials: true,
			})
			if (response.data.message) {
				alert(response.data.message)
			}
			await getAllProducingOrders()
		} catch (error) {
			handleError(error)
			dispatch(currentUserActions.isLogout())
			navigate('/login')
		}
	}

	return (
		<UserLayout>
			<Box
				sx={{
					maxWidth: 992,
					margin: '20px auto 0',
				}}>
				<Backdrop
					sx={{
						color: '#fff',
						zIndex: 999,
						left: mediaMd ? 300 : 0,
					}}
					open={isViewerOpen}
					onClick={closeImageViewer}>
					<img
						loading='lazy'
						src={currentImage}
						alt='attach'
						style={{
							maxHeight: '70%',
							maxWidth: '90%',
						}}
						onClick={(e) => {
							e.stopPropagation()
						}}
					/>
				</Backdrop>
				{loading && (
					<Box sx={{ textAlign: 'center', mt: 4 }}>
						<CircularProgress sx={{ color: mainGreen }} />
					</Box>
				)}
				{!loading && allProducingOrders?.length === 0 && (
					<Card sx={{ padding: '10px', marginTop: '-20px' }}>
						<Typography sx={{ fontWeight: 'bold' }}>Chưa có đơn hàng đang xử lý</Typography>
					</Card>
				)}
				{!loading &&
					allProducingOrders?.map((item, index) => {
						return (
							<Box sx={{ mb: 2, padding: '0 16px' }} key={index}>
								<Backdrop
									sx={{
										color: '#fff',
										zIndex: (theme) => theme.zIndex.drawer + 1,
										left: mediaMd ? 300 : 0,
									}}
									open={showShippingServicesBackdrop}
									onClick={() => {
										setShowShippingServicesBackdrop(false)
										handleShippingFee(currentOrder)
									}}>
									<Box
										onClick={(e) => {
											e.stopPropagation()
										}}>
										<Typography
											sx={{
												textAlign: 'center',
												padding: '8px 10px',
												background: mainGreen,
												color: '#fff',
											}}>
											ĐƠN {currentOrderCode}
										</Typography>
										<Box
											sx={{
												background: '#fff',
												color: '#000',
												padding: '15px 20px 20px',
											}}>
											<TextField
												fullWidth
												type='text'
												label='Tiền ship (vnđ)'
												value={shippingFee}
												onChange={handleChangeShippingFee}
											/>
										</Box>
									</Box>
								</Backdrop>
								<Box sx={{ width: '100%' }}>
									<Box sx={styleOrder}>
										<p
											style={{
												marginTop: '-10px',
												marginBottom: '5px',
												fontSize: '10px',
												color: '#fff',
											}}>
											<span
												style={{
													background: mainGreen,
													padding: '1px 5px',
													borderRadius: '2px',
												}}>
												{' '}
												{item.shiftCode}
												{item.shiftIndex}
											</span>
										</p>
										<Box sx={{ position: 'absolute', right: '5px', top: '5px' }}>
											<Checkbox checked={item.checked} value={item._id} onChange={(e) => handleChangeCheck(e, item)} />
										</Box>
										{(item.shippingFee || item.shippingFee === 0) && (
											<Typography
												sx={{
													fontSize: '14px',
													marginBottom: '5px',
													color: '#fff',
													background: mainRed,
													display: 'inline-block',
													padding: '0 10px',
													borderRadius: '2px',
													letterSpacing: '2px',
												}}>
												{item.shippingFee.toLocaleString()}đ
											</Typography>
										)}
										<Typography
											sx={{
												fontSize: '12px',
												color: mainBlue,
												fontWeight: 'bold',
											}}>
											{item.producer.user.name} đang xử lý
										</Typography>
										<span
											style={{
												display: 'inline-block',
												width: '5px',
												height: '5px',
												background: mainGreen,
												borderRadius: '50%',
												marginRight: '5px',
												marginBottom: '2px',
											}}></span>
										<span style={{ fontWeight: 700, color: mainGreen }}>
											{item.quantity}kg - {item.totalPrice.toLocaleString()}đ
										</span>
										<br></br>
										<span
											dangerouslySetInnerHTML={{
												__html: transformDetailWithPhone(item.detail),
											}}></span>
										<br></br>
										{item?.edited?.value && (
											<Chip
												sx={{
													marginTop: '5px',
													mr: 1,
													mb: 1,
													fontStyle: 'italic',
													fontSize: '12px',
												}}
												size='small'
												label='Đã chỉnh sửa'
											/>
										)}
										{item.payment === 'transfer' && (
											<Chip
												sx={{
													marginTop: '5px',
													mr: 1,
													mb: 1,
													color: '#fff',
													background: mainGreen,
												}}
												size='small'
												label='CK'
											/>
										)}
										{item.app && (
											<Chip
												sx={{
													marginTop: '5px',
													mr: 1,
													mb: 1,
													color: '#fff',
													background: mainRed,
												}}
												size='small'
												label='App'
											/>
										)}
										{item.tag?.map((tag, index) => {
											return (
												<Chip
													sx={{
														marginTop: '5px',
														mr: 1,
														mb: 1,
														background: `${tag.color}`,
														color: '#fff',
														fontSize: '12px',
													}}
													size='small'
													key={index}
													label={tag.name}
												/>
											)
										})}
										<Box>
											{item.photoAttach.map((photo, index) => {
												return (
													<Fragment key={index}>
														<img
															loading='lazy'
															src={photo}
															onClick={(e) => {
																e.stopPropagation()
																openImageViewer(photo)
															}}
															width='30'
															height='30'
															style={{ margin: '2px', cursor: 'pointer' }}
															alt=''
														/>
													</Fragment>
												)
											})}
										</Box>
									</Box>
								</Box>
							</Box>
						)
					})}
				{!loading && (
					<Box>
						<Typography
							sx={{
								fontWeight: 'bold',
								textAlign: 'center',
								mt: 2,
								mb: 1,
								letterSpacing: '3px',
							}}>
							ĐƠN VỊ GIAO HÀNG
						</Typography>
						{shippingServices?.map((serviceItem, index) => (
							<Box
								key={index}
								sx={{
									background: '#fff',
									boxShadow: 'rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px',
								}}>
								<FormControlLabel
									sx={{
										width: '100%',
										'&:hover': { background: '#DFE3E8' },
										m: 0,
									}}
									control={
										<Radio
											checked={shippingService === serviceItem._id}
											value={serviceItem._id}
											onChange={(e) => handleChangeShippingService(e)}
										/>
									}
									label={serviceItem.name.toUpperCase()}
								/>
							</Box>
						))}
						<Button
							variant='contained'
							size='small'
							sx={{
								background: mainGreen,
								'&:hover': { background: mainGreen },
							}}
							fullWidth
							onClick={handleShippingService}>
							Xác nhận
						</Button>
					</Box>
				)}
			</Box>
		</UserLayout>
	)
}
